import React, { useState } from 'react';
import { usePriestAuth } from '../../context/PriestAuthContext';

export default function PriestProfile() {
  const { priest, updateProfile, priestFetch } = usePriestAuth();
  const [form, setForm] = useState({
    name: priest.name || '', phone: priest.phone || '',
    gotram: priest.gotram || '', kulaDeity: priest.kulaDeity || '',
    address: priest.address || '', languages: priest.languages || '',
    specialization: priest.specialization || '',
    experienceYears: priest.experienceYears || 0,
  });
  const [pw, setPw] = useState({ currentPassword: '', newPassword: '', confirm: '' });
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');
  const [saving, setSaving] = useState(false);

  const update = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const save = async (e) => {
    e.preventDefault();
    setSaving(true); setMsg(''); setErr('');
    try {
      await updateProfile(form);
      setMsg('✅ Profile updated');
    } catch (e) { setErr(e.message); }
    finally { setSaving(false); }
  };

  const changePw = async (e) => {
    e.preventDefault();
    setMsg(''); setErr('');
    if (pw.newPassword.length < 8) return setErr('Password must be at least 8 characters');
    if (pw.newPassword !== pw.confirm) return setErr('Passwords do not match');
    try {
      await priestFetch('/api/priest/auth/change-password', {
        method: 'POST',
        body: JSON.stringify({
          currentPassword: pw.currentPassword,
          newPassword: pw.newPassword,
        }),
      });
      setMsg('✅ Password changed');
      setPw({ currentPassword: '', newPassword: '', confirm: '' });
    } catch (e) { setErr(e.message); }
  };

  return (
    <div className="pp-wrapper">
      {msg && <div className="pp-msg pp-msg-ok">{msg}</div>}
      {err && <div className="auth-error">⚠️ {err}</div>}

      <div className="mc-grid">
        <div className="mc-form-card">
          <h3>👤 Profile Information</h3>
          <form onSubmit={save}>
            <div className="form-row-2">
              <Field label="Name" value={form.name} onChange={v => update('name', v)} />
              <Field label="Phone" value={form.phone} onChange={v => update('phone', v)} />
            </div>
            <div className="form-row-2">
              <Field label="Gotram" value={form.gotram} onChange={v => update('gotram', v)} />
              <Field label="Kula Deity" value={form.kulaDeity} onChange={v => update('kulaDeity', v)} />
            </div>
            <Field label="Address" value={form.address} onChange={v => update('address', v)} />
            <div className="form-row-2">
              <Field label="Languages" value={form.languages}
                placeholder="e.g. Telugu, Sanskrit, English"
                onChange={v => update('languages', v)} />
              <Field label="Experience (years)" type="number" value={form.experienceYears}
                onChange={v => update('experienceYears', v)} />
            </div>
            <Field label="Specialization" value={form.specialization}
              placeholder="e.g. Marriage, Griha Pravesh, Vastu"
              onChange={v => update('specialization', v)} />

            <button type="submit" className="btn btn-primary" disabled={saving}>
              {saving ? 'Saving...' : '💾 Save Profile'}
            </button>
          </form>
        </div>

        <div className="mc-form-card">
          <h3>🔐 Change Password</h3>
          <form onSubmit={changePw}>
            <div className="form-group">
              <label>Current Password</label>
              <input type="password" value={pw.currentPassword}
                onChange={e => setPw(p => ({ ...p, currentPassword: e.target.value }))} />
            </div>
            <div className="form-group">
              <label>New Password</label>
              <input type="password" value={pw.newPassword}
                onChange={e => setPw(p => ({ ...p, newPassword: e.target.value }))} />
            </div>
            <div className="form-group">
              <label>Confirm New Password</label>
              <input type="password" value={pw.confirm}
                onChange={e => setPw(p => ({ ...p, confirm: e.target.value }))} />
            </div>
            <button type="submit" className="btn btn-primary">Change Password</button>
          </form>

          <div className="pp-account-info">
            <h4>Account</h4>
            <p>Email: <strong>{priest.email}</strong></p>
            <p>Verified: <strong>{priest.isVerified ? '✅ Yes' : '⏳ Pending'}</strong></p>
            <p>Member since: <strong>{priest.createdAt?.slice(0, 10)}</strong></p>
          </div>
        </div>
      </div>
    </div>
  );
}

function Field({ label, type = 'text', value, onChange, placeholder }) {
  return (
    <div className="form-group">
      <label>{label}</label>
      <input type={type} value={value} placeholder={placeholder}
        onChange={e => onChange(e.target.value)} />
    </div>
  );
}
